import { PATH } from 'data';

export const __PanelNoMenuRoutes = [
    PATH.panel.addPost.index(),
    PATH.panel.myAds.edit(),
    PATH.panel.chat(),
    PATH.panel.myAds.preview(),
];
